/* ==========================================================================
   Product gallery dots.

   Dawn puts dot behaviour in SlideshowComponent (active state + click to
   slide). The product gallery uses the plain <slider-component>, which has
   neither — but it does dispatch `slideChanged` with a 1-based currentPage,
   and that is all this needs.

   Nothing here re-implements scrolling. Clicking a dot scrolls the slider's own
   scroll container, so the snap, the momentum and the arrows keep working and
   stay in sync for free.
   ========================================================================== */
(function () {
  'use strict';

  function init(slider) {
    var dotsRow = slider.querySelector('[data-cs-galdots]');
    var track = slider.querySelector('[id^="Slider-"]');
    if (!dotsRow || !track) return;

    var dots = Array.prototype.slice.call(dotsRow.querySelectorAll('[data-cs-galdot]'));
    if (dots.length < 2) {
      dotsRow.hidden = true;
      return;
    }

    /* A sliding WINDOW of five marks, sized by distance from the current one.

       Measured off the reference (myfrido.com PDP): five marks always, the
       current one a 21x6 bar and the rest circles that step down 6 / 5 / 4 / 3
       as they get further away, in a row with a 6px gap.

       Two things that are easy to get wrong and that the reference gets right:
       the count stays at FIVE even at the ends — on slide 1 you see the bar
       plus four shrinking dots to its right, not a stump of three — and the
       size is a function of distance from the CURRENT slide, not of position in
       the window. So `start` slides to keep five in view while `dist` decides
       how big each one draws.

       CSS owns every dimension; this only publishes which bucket each mark is
       in. Marks outside the window leave the tab order too — a zero-width
       button is still focusable, and tabbing onto something invisible is worse
       than not offering it.  */
    var WINDOW = 5;

    function mark(page) {
      var n = dots.length;
      var i = Math.max(0, Math.min(n - 1, page - 1));
      var span = Math.min(WINDOW, n);
      var start = n <= WINDOW ? 0 : Math.max(0, Math.min(i - Math.floor(WINDOW / 2), n - WINDOW));

      dots.forEach(function (d, k) {
        var inWindow = k >= start && k < start + span;
        var dist = Math.abs(k - i);
        var state = !inWindow ? 'is-out' : dist === 0 ? 'is-active' : 'is-d' + Math.min(dist, 4);

        d.className = 'cs-galdots__dot ' + state;

        if (dist === 0) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');

        if (inWindow) {
          d.removeAttribute('tabindex');
          d.removeAttribute('aria-hidden');
        } else {
          d.setAttribute('tabindex', '-1');
          d.setAttribute('aria-hidden', 'true');
        }
      });
    }

    slider.addEventListener('slideChanged', function (e) {
      mark(e.detail.currentPage);
    });

    mark(1);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slides = slider.querySelectorAll('[id^="Slide-"]');
        var target = slides[i];
        if (!target) return;
        /* offsetLeft difference rather than scrollIntoView: the latter also
           scrolls the PAGE vertically to bring the gallery into view, which
           yanks the reader away from wherever they were. */
        track.scrollTo({
          left: target.offsetLeft - slides[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        mark(i + 1);
      });
    });
  }

  function boot() {
    document.querySelectorAll('slider-component').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
